import { createCrumb } from './createCrumb';

import type { Crumb } from 'layout/MainLayout/components/Header/hooks/useCrumbs/types';

export const handleStringCrumb = (
  currentHandle: string,
  pathname: string,
  acc: Crumb[],
): Crumb[] => [...acc, createCrumb(currentHandle, pathname)];
